import { Fragment } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

// import ProfileComponent from "./pages/ProfileComponent";
import InvoiceTracking from "../pages/InvoiceTracking";
import CreateClaim from "./pages/CreateClaim";
// import PerDiem from "./pages/PerDiem";
// import InvoiceDetail from "./pages/InvoiceDetail";
import FinanceApprovalOld from "./pages/FinanceApproval";
import ManagerApprovalOld from "./pages/ManagerApproval";
// import FinanceMasterApproval from "./pages/FinanceMasterApproval";
// import ManagerMasterApproval from "./pages/ManagerMasterApproval";
import InvoiceMasterTracking from "./pages/InvoiceMasterTracking";
import TablePerDiem from "./pages/TablePerDiem";
// import AllInvoices from "./Reports/AllInvoices";
import AdminInProgress from "@/pages/AdminInProgress";
import AdminManage from "@/pages/AdminManage";
import AllInvoices from "@/pages/AllInvoices";
import AllJobApprovals from "@/pages/AllJobApprovals";
import CashOfficeCollection from "@/pages/CashOfficeCollection";
import CashOfficeReports from "@/pages/CashOfficeReports";
import CFOJobApproval from "@/pages/CFOJobApproval";
import CFOJobApprovals from "@/pages/CFOJobApprovals";
import CreateExternalContributor from "@/pages/CreateExternalContributor";
import CreateJob from "@/pages/CreateJob";
import FinanceApproval from "@/pages/FinanceApproval";
import FinanceApprovals from "@/pages/FinanceApprovals";
import FinanceJobApproval from "@/pages/FinanceJobApproval";
import FinanceJobApprovals from "@/pages/FinanceJobApprovals";
import FinanceSecondaryApproval from "@/pages/FinanceSecondaryApproval";
import GeneralReport from "@/pages/GeneralReport";
import HRManagerJobApproval from "@/pages/HRManagerJobApproval";
import HRManagerJobApprovals from "@/pages/HRManagerJobApprovals";
import HRPartnerJobApproval from "@/pages/HRPartnerJobApproval";
import HRPartnerJobApprovals from "@/pages/HRPartnerJobApprovals";
import JobApprovalDetails from "@/pages/JobApprovalDetails";
import ManagerApporvals from "@/pages/ManagerApporvals";
import ManagerApproval from "@/pages/ManagerApproval";
import ManagerContributorApproval from "@/pages/ManagerContributorApproval";
import ManagerSecondaryApproval from "@/pages/ManagerSecondaryApproval";
import MyInvoice from "@/pages/MyInvoice";
import NotFound from "@/pages/NotFound";
import SystemUser from "@/pages/SystemUser";
import SystemUsers from "@/pages/SystemUsers";
import Profile from "../pages/Profile";
import ReleasePayments from "../pages/ReleasePayments";
import EditUserById from "./common/EditUserById";
import Header from "./layout/Header";
import Sidebar from "./layout/Sidebar";
import CashAllocation from "./pages/CashAllocation";
import ApprovedInvoices from "./Reports/ApprovedInvoices";
import DateSelection from "./Reports/CashOfficeReports/DateSelection";
import InvoiceDetailGeneral from "./Reports/InvoiceDetailGeneral";
import InvoiceDetailPaid from "./Reports/InvoiceDetailPaid";
import ProgressInvoices from "./Reports/ProgressInvoices";
import RejectedInvoices from "./Reports/RejectedInvoices";

const RouteComponent = () => {
	return (
		<main className="h-screen w-full">
			<Router>
				<Fragment>
					{/* <Routes>
                    <Route path="/" component={Login} />
                    </Routes>    */}
					{/* <Navbar /> */}
					<Sidebar />
					<div className="lg:ml-[300px] grow">
						<Header />
						<div className="p-4">
							<Routes>
								<Fragment>
									<Route path="/" element={<InvoiceTracking />}></Route>
									{/* <Route path="/profile" element={<ProfileComponent />}></Route> */}
									<Route path="/profile" element={<Profile />}></Route>
									<Route path="/createclaim" element={<CreateClaim />}></Route>
									<Route
										path="/create-external-contributor"
										element={<CreateExternalContributor />}
									></Route>
									{/* <Route path="/invoicetracking" element={<InvoiceTracking />}></Route> */}
									{/* <Route path="/perdiem" element={<PerDiem/>}></Route> */}
									{/* <Route path="/invoicedetail" element={<InvoiceDetail/>}></Route> */}
									<Route
										path="/managerapprovelist"
										element={<ManagerApporvals />}
									></Route>
									<Route
										path="/managersecondaryapproval/:id"
										element={<ManagerSecondaryApproval />}
									></Route>
									<Route
										path="/manager-contributor-approval/:id"
										element={<ManagerContributorApproval />}
									></Route>
									<Route
										path="/financeapprovelist"
										element={<FinanceApprovals />}
									></Route>
									<Route
										path="/financesecondaryapproval/:id"
										element={<FinanceSecondaryApproval />}
									></Route>
									<Route
										path="/managerapproval"
										element={<ManagerApprovalOld />}
									></Route>
									<Route
										path="/managerapproval/:id"
										element={<ManagerApproval />}
									></Route>
									<Route
										path="/financeapproval"
										element={<FinanceApprovalOld />}
									></Route>
									<Route
										path="/financeapproval/:id"
										element={<FinanceApproval />}
									></Route>
									{/* <Route path="/financeapprovalmaster" element={<FinanceMasterApproval/>}></Route> */}
									{/* <Route path="/managerapprovalmaster" element={<ManagerMasterApproval/>}></Route> */}
									<Route
										path="/invoicemastertracking"
										element={<InvoiceMasterTracking />}
									></Route>
									<Route path="/admin" element={<AdminInProgress />}></Route>
									<Route path="/admin/:id" element={<AdminManage />}></Route>
									<Route path="/claim/:id" element={<MyInvoice />}></Route>
									<Route path="/tableperdiem" element={<TablePerDiem />}></Route>
									<Route path="/allclaims" element={<AllInvoices />}></Route>
									<Route path="/allusers" element={<SystemUsers />}></Route>
									<Route path="/allusers/:id" element={<SystemUser />}></Route>
									<Route
										path="/invoicesinprogress"
										element={<ProgressInvoices />}
									></Route>
									<Route path="/approvedinvoices" element={<ApprovedInvoices />}></Route>
									<Route path="/rejectedinvoices" element={<RejectedInvoices />}></Route>
									<Route
										path="/invoicedetailgeneral"
										element={<InvoiceDetailGeneral />}
									></Route>
									<Route path="/cashallocation" element={<CashAllocation />}></Route>
									<Route
										path="/cashcollection/:id"
										element={<CashOfficeCollection />}
									></Route>
									<Route path="/release-payments" element={<ReleasePayments />}></Route>
									<Route path="/paidclaims" element={<CashOfficeReports />}></Route>
									<Route path="/generalreport/:id" element={<GeneralReport />}></Route>
									<Route
										path="/invoicedetailpaid"
										element={<InvoiceDetailPaid />}
									></Route>
									<Route path="/cashofficereports" element={<DateSelection />}></Route>
									<Route path="/edituserbyid" element={<EditUserById />}></Route>
									<Route path="/createjob" element={<CreateJob />}></Route>
									<Route
										path="/finance-job-approvals"
										element={<FinanceJobApprovals />}
									></Route>
									<Route
										path="/finance-job-approval/:id"
										element={<FinanceJobApproval />}
									></Route>
									<Route
										path="/hr-partner-job-approvals"
										element={<HRPartnerJobApprovals />}
									></Route>
									<Route
										path="/hr-partner-job-approval/:id"
										element={<HRPartnerJobApproval />}
									></Route>
									<Route
										path="/hr-manager-job-approvals"
										element={<HRManagerJobApprovals />}
									></Route>
									<Route
										path="/hr-manager-job-approval/:id"
										element={<HRManagerJobApproval />}
									></Route>
									<Route path="/cfo-job-approvals" element={<CFOJobApprovals />}></Route>
									<Route
										path="/cfo-job-approval/:id"
										element={<CFOJobApproval />}
									></Route>
									<Route path="/all-job-approvals" element={<AllJobApprovals />}></Route>
									<Route
										path="/job-approval/:id"
										element={<JobApprovalDetails />}
									></Route>
									<Route path="*" element={<NotFound />} />
								</Fragment>
							</Routes>
						</div>
					</div>
				</Fragment>
			</Router>
		</main>
	);
};

export default RouteComponent;
